import "./base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Models ??= {};

AssessmentBuilder.Models.Response = class Response extends AssessmentBuilder.Models.Base {
  defaults() {
    return {
      text: "",
      points: 0,
      position: null,
      nextQuestion: null,
      image: null,
    };
  }
};
AssessmentBuilder.Models.Response.initializeRelations();
